import { render, staticRenderFns } from "./userLayout.vue?vue&type=template&id=838eb9e8&scoped=true&"
import script from "./userLayout.vue?vue&type=script&lang=js&"
export * from "./userLayout.vue?vue&type=script&lang=js&"
import style0 from "./userLayout.vue?vue&type=style&index=0&id=838eb9e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "838eb9e8",
  null
  
)

export default component.exports